import { get } from 'lodash';

import httpFactory from '@core/api/instance/http-factory';

const MINUTES = 60 * 1000;
export const NOTIFICATIONS_LIMIT = 20;

const notificationsCountHttp = httpFactory({ baseURL: configurationURL.notificationsCount.baseUrl });
const userNotificationsHttp = httpFactory({ baseURL: configurationURL.userNotifications.baseUrl });
const accountNotificationsHttp = httpFactory({ baseURL: configurationURL.accountNotifications.baseUrl });

export const getNotificationsCount = ({ forceUpdate = false } = {}) =>
  notificationsCountHttp
    .get('', {
      forceUpdate,
      ignore404: true,
    })
    .then(resp => {
      const userCount = parseInt(get(resp.data, 'user_notifications', 0), 10);
      const accountCount = parseInt(get(resp.data, 'account_notifications', 0), 10);
      return userCount + accountCount;
    });

export const getUserNotifications = ({ offset = 0 } = {}, { forceUpdate = false } = {}) =>
  userNotificationsHttp
    .get('/user_notifications', {
      throttle: 5 * MINUTES,
      forceUpdate,
      ignore404: true,
      params: {
        offset,
        limit: NOTIFICATIONS_LIMIT,
      },
    })
    .then(resp => resp.data);

export const getAccountNotifications = ({ accountId, offset = 0 }, { forceUpdate = false } = {}) =>
  accountNotificationsHttp
    .get('/account_notifications', {
      throttle: 5 * MINUTES,
      forceUpdate,
      ignore404: true,
      params: {
        account_id: accountId,
        offset,
        limit: NOTIFICATIONS_LIMIT,
      },
    })
    .then(resp => resp.data);

export const dismissUserNotification = id =>
  userNotificationsHttp.delete(`/user_notifications/${id}`).then(resp => resp.data);

export const dismissAccountNotification = (id, accountId) =>
  accountNotificationsHttp
    .delete(`/account_notifications/${id}`, {
      params: {
        account_id: accountId,
      },
    })
    .then(resp => resp.data);
